import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const AR = createSvgIcon(
  <path d="M0 0v5.25h2.25v-3h3V0H0Zm3.75 6.292L12 3.774l8.25 2.518v10.591L12 20.226l-8.25-3.343V6.293ZM18 15.367v-7.41L13.125 6.47v10.873L18 15.367Zm-7.125 1.976V6.47L6 7.958v7.41l4.875 1.975ZM24 5.25V0h-5.25v2.25h3v3H24ZM0 24v-5.25h2.25v3h3V24H0Zm24-5.25V24h-5.25v-2.25h3v-3H24Z" />,
  'AR'
);

export { AR };